import { AuthorizationTokenSelectSchema, CustomerLoginCodeSelectSchema, } from "@norskgassnett/db";
import { z } from "zod";
import { CustomerCustom } from "../business_central.js";
export const Identity = z
    .object({
    customer: CustomerCustom.optional(),
    bcId: CustomerCustom.shape.id.optional(),
})
    .meta({ ref: "Identity" });
export const ReauthenticateResponseBody = z
    .object({
    token: AuthorizationTokenSelectSchema.shape.token,
    expiresIn: z.number(),
})
    .meta({ ref: "ReauthenticateResponseBody" });
export const SwitchCustomerRequestBody = z
    .object({
    bcId: z.string(),
})
    .meta({ ref: "SwitchCustomerRequestBody" });
export const SwitchCustomerResponseBody = ReauthenticateResponseBody.meta({
    ref: "SwitchCustomerResponseBody",
});
export const ParsedCustomer = z
    .object({
    bcId: z.string(),
    name: z.string(),
    address: z.string(),
})
    .meta({ ref: "ParsedCustomer" });
export const MeResponseBody = z
    .object({
    current: CustomerCustom,
    linked: ParsedCustomer.array(),
})
    .meta({ ref: "MeResponseBody" });
export const StartLoginCustomerFlowRequestBody = CustomerLoginCodeSelectSchema.pick({ identifier: true }).meta({
    ref: "StartLoginCustomerFlowRequestBody",
});
export const StartLoginCustomerFlowResponseBody = z
    .object({
    flowId: CustomerLoginCodeSelectSchema.shape.id,
})
    .meta({
    ref: "StartLoginCustomerFlowResponseBody",
});
export const CompleteLoginCustomerFlowRequestBody = z
    .object({
    flowId: CustomerLoginCodeSelectSchema.shape.id,
    code: CustomerLoginCodeSelectSchema.shape.code,
})
    .meta({ ref: "CompleteLoginCustomerFlowRequestBody" });
export const CompleteLoginCustomerFlowResponseBody = z
    .object({
    token: AuthorizationTokenSelectSchema.shape.token,
    expiresIn: z.number(),
})
    .meta({ ref: "CompleteLoginCustomerFlowResponseBody" });
